import { motion } from "framer-motion";
import { PARTNERS, PARTNERS_INTRO } from "@/data/content";
import { useT } from "@/i18n/LanguageContext";

export const Partners = () => {
  const t = useT();

  return (
    <section id="partneri" data-testid="partners-section" className="relative py-24 lg:py-32 wf-mesh">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="uppercase text-xs tracking-[0.25em] text-[#1A1A1F] font-bold">
            {t(PARTNERS_INTRO.eyebrow)}
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight mt-4">
            {t(PARTNERS_INTRO.title)}
          </h2>
          <p className="text-[#62646B] leading-relaxed mt-6">{t(PARTNERS_INTRO.description)}</p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-6 mt-14">
          {PARTNERS.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`partner-card-${i}`}
              className={`p-8 lg:p-10 rounded-3xl border transition-colors duration-300 ${
                p.active
                  ? "bg-white border-[#0A0A0F]/20 wf-glow"
                  : "bg-[#F4F2EC]/70 border-[#E8E7E2]"
              }`}
            >
              <span
                className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10px] uppercase tracking-[0.2em] font-bold ${
                  p.active
                    ? "bg-[#0A0A0F] text-white"
                    : "border border-[#E8E7E2] text-[#62646B]"
                }`}
              >
                {p.active && <span className="wf-pulse-dot w-1.5 h-1.5 rounded-full bg-[#FAFAF7]" />}
                {t(p.status)}
              </span>

              <h3 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight mt-5">
                {t(p.name)}
              </h3>
              <p className="text-[#62646B] leading-relaxed mt-4">{t(p.desc)}</p>

              {p.amenities.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-6">
                  {p.amenities.map((a, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1.5 rounded-full border border-[#E8E7E2] text-xs text-[#1A1A1F] bg-white/60"
                    >
                      {t(a)}
                    </span>
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
